module.exports = __webpack_public_path__ + "static/media/channel-atm.bd73f601.svg";